var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93787 60C3.61693 60 1.96726 58.9167 0.988873 56.75C0.0104287 54.5833 0.326762 52.6111 1.93787 50.8333L22.6045 27.5V5H18.2712C17.5629 5 16.9691 4.75903 16.49 4.27708C16.0108 3.79508 15.7712 3.19786 15.7712 2.48542C15.7712 1.77292 16.0108 1.18056 16.49 0.708333C16.9691 0.236111 17.5629 0 18.2712 0H44.9379C45.6462 0 46.24 0.240971 46.7191 0.722916C47.1983 1.20492 47.4379 1.80214 47.4379 2.51458C47.4379 3.22708 47.1983 3.81944 46.7191 4.29167C46.24 4.76389 45.6462 5 44.9379 5H40.6045V27.5L61.2712 50.8333C62.8823 52.6111 63.1987 54.5833 62.2202 56.75C61.2418 58.9167 59.5922 60 57.2712 60H5.93787ZM4.93787 55H58.2712L35.6045 29.3333V5H27.6045V29.3333L4.93787 55Z",
    fill: "#708130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.163bd68b49afa2b29270b891ba3a9f88.svg";
export { ForwardRef as ReactComponent };